<div class="control" (click)="setFocus()"
     [ngClass]="{'active': focussed , 'disabled':disabled}">
    <div class="control-label">
        <label class="control-label-title">
            {{ label | translate }}
        </label>
    </div>
    <div class="control-field">
        @if (icon) {
            <div class="control-field-action">
                <div class="control-field-action-media">
                    <ng-content select="fui-icon"></ng-content>
                </div>
            </div>
        }
        <input (blur)="onBlur($event)" class="control-field-input" [disabled]="disabled" (focus)="onFocus($event)"
               #input
               [type]="type" [(ngModel)]="value" [placeholder]="placeholder | translate">
        @if (notation) {
            <div class="control-field-notation">
                <div class="control-field-notation-title">
                    {{ notation }}
                </div>
            </div>
        }
    </div>
</div>
